export enum NotificationChannelEnum {
    SMS = "SMS",
    EMAIL = "EMAIL",
    PUSH = "PUSH"
}